import { SELECTORS } from './constants';

export class FlavorSwitcher {
  constructor(container, onClick) {
    this.options = container.querySelectorAll(`.${SELECTORS.FLAVOR_OPTION}`);
    this.onClick = onClick;
  }

  handleClick = ({ currentTarget: { dataset: { productId }}}) => {
    this?.onClick(productId);
  };

  init = () => {
    if (this.options.length > 1) {
      this.options.forEach((option) => {
        option.addEventListener('click', this.handleClick);
      });
    }
  };
}
